export default "__VITE_ASSET__uhNjJLQs__"